import moment from 'moment';
import MomentTimezone from 'moment-timezone';

export const VALID_TIMEZONES = [
  'Africa/Abidjan',
  'Africa/Algiers',
  'Africa/Bissau',
  'Africa/Cairo',
  'Africa/Casablanca',
  'Africa/Ceuta',
  'Africa/El_Aaiun',
  'Africa/Johannesburg',
  'Africa/Juba',
  'Africa/Khartoum',
  'Africa/Lagos',
  'Africa/Maputo',
  'Africa/Monrovia',
  'Africa/Nairobi',
  'Africa/Ndjamena',
  'Africa/Sao_Tome',
  'Africa/Tripoli',
  'Africa/Tunis',
  'Africa/Windhoek',
  'America/Adak',
  'America/Anchorage',
  'America/Araguaina',
  'America/Argentina/Buenos_Aires',
  'America/Argentina/Catamarca',
  'America/Argentina/Cordoba',
  'America/Argentina/Jujuy',
  'America/Argentina/La_Rioja',
  'America/Argentina/Mendoza',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Salta',
  'America/Argentina/San_Juan',
  'America/Argentina/San_Luis',
  'America/Argentina/Tucuman',
  'America/Argentina/Ushuaia',
  'America/Bahia',
  'America/Bahia_Banderas',
  'America/Barbados',
  'America/Belem',
  'America/Belize',
  'America/Boa_Vista',
  'America/Bogota',
  'America/Boise',
  'America/Cambridge_Bay',
  'America/Campo_Grande',
  'America/Cancun',
  'America/Caracas',
  'America/Cayenne',
  'America/Chicago',
  'America/Chihuahua',
  'America/Costa_Rica',
  'America/Cuiaba',
  'America/Danmarkshavn',
  'America/Dawson',
  'America/Dawson_Creek',
  'America/Denver',
  'America/Detroit',
  'America/Edmonton',
  'America/Eirunepe',
  'America/El_Salvador',
  'America/Fortaleza',
  'America/Glace_Bay',
  'America/Goose_Bay',
  'America/Grand_Turk',
  'America/Guatemala',
  'America/Guayaquil',
  'America/Guyana',
  'America/Halifax',
  'America/Havana',
  'America/Hermosillo',
  'America/Indiana/Indianapolis',
  'America/Indiana/Knox',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Tell_City',
  'America/Indiana/Vevay',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Inuvik',
  'America/Iqaluit',
  'America/Jamaica',
  'America/Juneau',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/La_Paz',
  'America/Lima',
  'America/Los_Angeles',
  'America/Maceio',
  'America/Managua',
  'America/Manaus',
  'America/Martinique',
  'America/Matamoros',
  'America/Mazatlan',
  'America/Menominee',
  'America/Merida',
  'America/Metlakatla',
  'America/Mexico_City',
  'America/Miquelon',
  'America/Moncton',
  'America/Monterrey',
  'America/Montevideo',
  'America/New_York',
  'America/Nome',
  'America/Noronha',
  'America/North_Dakota/Beulah',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/Ojinaga',
  'America/Panama',
  'America/Paramaribo',
  'America/Phoenix',
  'America/Port-au-Prince',
  'America/Porto_Velho',
  'America/Puerto_Rico',
  'America/Rankin_Inlet',
  'America/Recife',
  'America/Regina',
  'America/Resolute',
  'America/Rio_Branco',
  'America/Santarem',
  'America/Santiago',
  'America/Santo_Domingo',
  'America/Sao_Paulo',
  'America/Scoresbysund',
  'America/Sitka',
  'America/St_Johns',
  'America/Swift_Current',
  'America/Tegucigalpa',
  'America/Thule',
  'America/Tijuana',
  'America/Toronto',
  'America/Vancouver',
  'America/Whitehorse',
  'America/Winnipeg',
  'America/Yakutat',
  'Antarctica/Casey',
  'Antarctica/Davis',
  'Antarctica/Macquarie',
  'Antarctica/Mawson',
  'Antarctica/Palmer',
  'Antarctica/Rothera',
  'Antarctica/Troll',
  'Asia/Almaty',
  'Asia/Amman',
  'Asia/Anadyr',
  'Asia/Aqtau',
  'Asia/Aqtobe',
  'Asia/Ashgabat',
  'Asia/Baghdad',
  'Asia/Baku',
  'Asia/Bangkok',
  'Asia/Beirut',
  'Asia/Bishkek',
  'Asia/Chita',
  'Asia/Choibalsan',
  'Asia/Colombo',
  'Asia/Damascus',
  'Asia/Dhaka',
  'Asia/Dili',
  'Asia/Dubai',
  'Asia/Dushanbe',
  'Asia/Gaza',
  'Asia/Hebron',
  'Asia/Ho_Chi_Minh',
  'Asia/Hong_Kong',
  'Asia/Hovd',
  'Asia/Irkutsk',
  'Asia/Jakarta',
  'Asia/Jayapura',
  'Asia/Jerusalem',
  'Asia/Kabul',
  'Asia/Kamchatka',
  'Asia/Karachi',
  'Asia/Kathmandu',
  'Asia/Khandyga',
  'Asia/Kolkata',
  'Asia/Krasnoyarsk',
  'Asia/Kuching',
  'Asia/Macau',
  'Asia/Magadan',
  'Asia/Makassar',
  'Asia/Manila',
  'Asia/Nicosia',
  'Asia/Novokuznetsk',
  'Asia/Novosibirsk',
  'Asia/Omsk',
  'Asia/Oral',
  'Asia/Pontianak',
  'Asia/Pyongyang',
  'Asia/Qatar',
  'Asia/Qyzylorda',
  'Asia/Riyadh',
  'Asia/Sakhalin',
  'Asia/Samarkand',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Srednekolymsk',
  'Asia/Taipei',
  'Asia/Tashkent',
  'Asia/Tbilisi',
  'Asia/Tehran',
  'Asia/Thimphu',
  'Asia/Tokyo',
  'Asia/Ulaanbaatar',
  'Asia/Urumqi',
  'Asia/Ust-Nera',
  'Asia/Vladivostok',
  'Asia/Yakutsk',
  'Asia/Yekaterinburg',
  'Asia/Yerevan',
  'Atlantic/Azores',
  'Atlantic/Bermuda',
  'Atlantic/Canary',
  'Atlantic/Cape_Verde',
  'Atlantic/Faroe',
  'Atlantic/Madeira',
  'Atlantic/South_Georgia',
  'Atlantic/Stanley',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Broken_Hill',
  'Australia/Darwin',
  'Australia/Eucla',
  'Australia/Hobart',
  'Australia/Lindeman',
  'Australia/Lord_Howe',
  'Australia/Melbourne',
  'Australia/Perth',
  'Australia/Sydney',
  'Europe/Andorra',
  'Europe/Athens',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Brussels',
  'Europe/Bucharest',
  'Europe/Budapest',
  'Europe/Chisinau',
  'Europe/Dublin',
  'Europe/Gibraltar',
  'Europe/Helsinki',
  'Europe/Istanbul',
  'Europe/Kaliningrad',
  'Europe/Lisbon',
  'Europe/London',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Minsk',
  'Europe/Moscow',
  'Europe/Paris',
  'Europe/Prague',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/Samara',
  'Europe/Simferopol',
  'Europe/Sofia',
  'Europe/Tallinn',
  'Europe/Tirane',
  'Europe/Vienna',
  'Europe/Vilnius',
  'Europe/Volgograd',
  'Europe/Warsaw',
  'Europe/Zagreb',
  'Europe/Zaporozhye',
  'Europe/Zurich',
  'Indian/Chagos',
  'Indian/Maldives',
  'Indian/Mauritius',
  'Pacific/Apia',
  'Pacific/Auckland',
  'Pacific/Bougainville',
  'Pacific/Chatham',
  'Pacific/Chuuk',
  'Pacific/Easter',
  'Pacific/Efate',
  'Pacific/Fakaofo',
  'Pacific/Fiji',
  'Pacific/Galapagos',
  'Pacific/Gambier',
  'Pacific/Guadalcanal',
  'Pacific/Guam',
  'Pacific/Honolulu',
  'Pacific/Kiritimati',
  'Pacific/Kosrae',
  'Pacific/Kwajalein',
  'Pacific/Marquesas',
  'Pacific/Nauru',
  'Pacific/Niue',
  'Pacific/Norfolk',
  'Pacific/Noumea',
  'Pacific/Pago_Pago',
  'Pacific/Palau',
  'Pacific/Pitcairn',
  'Pacific/Port_Moresby',
  'Pacific/Rarotonga',
  'Pacific/Tahiti',
  'Pacific/Tarawa',
  'Pacific/Tongatapu',
  'UTC'
];

export const DEPRECATED_TIMEZONES = {
  'America/Indianapolis': 'America/Indiana/Indianapolis',
  'America/Fort_Wayne': 'America/Indiana/Indianapolis',
  'America/Louisville': 'America/Kentucky/Louisville',
  'America/Cordoba': 'America/Argentina/Cordoba',
  'America/Montreal': 'America/Toronto',
  'America/Jujuy': 'America/Argentina/Cordoba',
  'Asia/Calcutta': 'Asia/Kolkata',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Australia/Currie': 'Australia/Hobart',
  'Africa/Accra': 'Africa/Abidjan',
  'Africa/Addis_Ababa': 'Africa/Nairobi',
  'Africa/Asmara': 'Africa/Nairobi',
  'Africa/Bamako': 'Africa/Abidjan',
  'Africa/Bangui': 'Africa/Lagos',
  'Africa/Banjul': 'Africa/Abidjan',
  'Africa/Blantyre': 'Africa/Maputo',
  'Africa/Brazzaville': 'Africa/Lagos',
  'Africa/Bujumbura': 'Africa/Maputo',
  'Africa/Conakry': 'Africa/Abidjan',
  'Africa/Dakar': 'Africa/Abidjan',
  'Africa/Dar_es_Salaam': 'Africa/Nairobi',
  'Africa/Djibouti': 'Africa/Nairobi',
  'Africa/Douala': 'Africa/Lagos',
  'Africa/Freetown': 'Africa/Abidjan',
  'Africa/Gaborone': 'Africa/Maputo',
  'Africa/Harare': 'Africa/Maputo',
  'Africa/Kampala': 'Africa/Nairobi',
  'Africa/Kigali': 'Africa/Maputo',
  'Africa/Kinshasa': 'Africa/Lagos',
  'Africa/Libreville': 'Africa/Lagos',
  'Africa/Lome': 'Africa/Abidjan',
  'Africa/Luanda': 'Africa/Lagos',
  'Africa/Lubumbashi': 'Africa/Maputo',
  'Africa/Lusaka': 'Africa/Maputo',
  'Africa/Malabo': 'Africa/Lagos',
  'Africa/Maseru': 'Africa/Johannesburg',
  'Africa/Mbabane': 'Africa/Johannesburg',
  'Africa/Mogadishu': 'Africa/Nairobi',
  'Africa/Niamey': 'Africa/Lagos',
  'Africa/Nouakchott': 'Africa/Abidjan',
  'Africa/Ouagadougou': 'Africa/Abidjan',
  'Africa/Porto-Novo': 'Africa/Lagos',
  'America/Anguila': 'America/Puerto_Rico',
  'America/Antigua': 'America/Puerto_Rico',
  'America/Aruba': 'America/Puerto_Rico',
  'America/Asuncion': 'America/Puerto_Rico',
  'America/Atikokan': 'America/Puerto_Rico',
  'America/Blanc-Sablon': 'America/Puerto_Rico',
  'America/Cayman': 'America/Panama',
  'America/Creston': 'America/Phoenix',
  'America/Curacao': 'America/Puerto_Rico',
  'America/Dominica': 'America/Puerto_Rico',
  'America/Grenada': 'America/Puerto_Rico',
  'America/Guadeloupe': 'America/Puerto_Rico',
  'America/Kralendijk': 'America/Puerto_Rico',
  'America/Lower_Princes': 'America/Puerto_Rico',
  'America/Marigot': 'America/Puerto_Rico',
  'America/Montserrat': 'America/Puerto_Rico',
  'America/Nassau': 'America/Toronto',
  'America/Nipigon': 'America/Toronto',
  'America/Pangnirtung': 'America/Iqaluit',
  'America/Port_of_Spain': 'America/Puerto_Rico',
  'America/Rainy_River': 'America/Winnipeg',
  'America/St_Barthelemy': 'America/Puerto_Rico',
  'America/St_Kitts': 'America/Puerto_Rico',
  'America/St_Lucia': 'America/Puerto_Rico',
  'America/St_Thomas': 'America/Puerto_Rico',
  'America/St_Vincent': 'America/Puerto_Rico',
  'America/Thunder_Bay': 'America/Toronto',
  'America/Tortola': 'America/Puerto_Rico',
  'America/Yellowknife': 'America/Edmonton',
  'Antarctica/DumontDUrville': 'Pacific/Port_Moresby',
  'Antarctica/McMurdo': 'Pacific/Auckland',
  'Antarctica/Syowa': 'Asia/Riyadh',
  'Antarctica/Vostok': 'Asia/Urumqi',
  'Arctic/Longyearbyen': 'Europe/Berlin',
  'Asia/Aden': 'Asia/Riyadh',
  'Asia/Bahrain': 'Asia/Qatar',
  'Asia/Brunei': 'Asia/Kuching',
  'Asia/Kuala_Lumpur': 'Asia/Singapore',
  'Asia/Kuwait': 'Asia/Riyadh',
  'Asia/Muscat': 'Asia/Dubai',
  'Asia/Phnom_Penh': 'Asia/Bangkok',
  'Asia/Vientiane': 'Asia/Bangkok',
  'Atlantic/Reykjavik': 'Africa/Abidjan',
  'Atlantic/St_Helena': 'Africa/Abidjan',
  'Europe/Bratislava': 'Europe/Prague',
  'Europe/Busingen': 'Europe/Zurich',
  'Europe/Copenhagen': 'Europe/Berlin',
  'Europe/Guernsey': 'Europe/London',
  'Europe/Isle_of_Man': 'Europe/London',
  'Europe/Jersey': 'Europe/London',
  'Europe/Kiev': 'Europe/Kyiv',
  'Europe/Ljubljana': 'Europe/Belgrade',
  'Europe/Luxembourg': 'Europe/Brussels',
  'Europe/Mariehamn': 'Europe/Helsinki',
  'Europe/Monaco': 'Europe/Paris',
  'Europe/Oslo': 'Europe/Berlin',
  'Europe/Podgorica': 'Europe/Belgrade',
  'Europe/San_Marino': 'Europe/Rome',
  'Europe/Sarajevo': 'Europe/Belgrade',
  'Europe/Skopje': 'Europe/Belgrade',
  'Europe/Stockholm': 'Europe/Berlin',
  'Europe/Uzhgorod': 'Europe/Kyiv',
  'Europe/Vaduz': 'Europe/Zurich',
  'Europe/Vatican': 'Europe/Rome',
  'Indian/Antananarivo': 'Africa/Nairobi',
  'Indian/Christmas': 'Asia/Bangkok',
  'Indian/Cocos': 'Asia/Yangon',
  'Indian/Comoro': 'Africa/Nairobi',
  'Indian/Kerguelen': 'Indian/Maldives',
  'Indian/Mahe': 'Asia/Dubai',
  'Indian/Mayotte': 'Africa/Nairobi',
  'Indian/Reunion': 'Asia/Dubai',
  'Pacific/Chuuk': 'Pacific/Port_Moresby',
  'Pacific/Enderbury': 'Pacific/Kanton',
  'Pacific/Funafuti': 'Pacific/Tarawa',
  'Pacific/Majuro': 'Pacific/Tarawa',
  'Pacific/Midway': 'Pacific/Pago_Pago',
  'Pacific/Pohnpei': 'Pacific/Guadalcanal',
  'Pacific/Saipan': 'Pacific/Guam',
  'Pacific/Wake': 'Pacific/Tarawa',
  'Pacific/Wallis': 'Pacific/Tarawa',
  'Europe/Amsterdam': 'Europe/Brussels'
};

export function convertDeprecatedTimezone(timezone: string) {
  const timezoneName = timezone.split(' ')[0];

  if (timezoneName in DEPRECATED_TIMEZONES) {
    const offset = moment.tz(timezoneName).utcOffset() ? moment.tz(timezoneName).format('Z') : '+00:00';
    return `${DEPRECATED_TIMEZONES[timezoneName]} (GMT${offset})`;
  }

  return timezone;
}

export function guessUserTimezone() {
  const tzGuess = MomentTimezone.tz.guess();

  if (VALID_TIMEZONES.includes(tzGuess)) {
    const tzOffset = MomentTimezone.tz(tzGuess).utcOffset() ? moment.tz(tzGuess).format('Z') : '+00:00';
    return `${tzGuess} (GMT${tzOffset})`;
  }
  if (tzGuess in DEPRECATED_TIMEZONES) {
    const resolvedTimezone = DEPRECATED_TIMEZONES[tzGuess];
    const tzOffset = MomentTimezone.tz(resolvedTimezone).utcOffset()
      ? moment.tz(resolvedTimezone).format('Z')
      : '+00:00';
    return `${resolvedTimezone} (GMT${tzOffset})`;
  }

  return '';
}

export type TimezoneListOption = {
  id: string;
  label: string;
  value: string;
  offset: string;
};

export const TIMEZONES_LIST: TimezoneListOption[] = VALID_TIMEZONES.sort((a: string, b: string) => {
  return a.localeCompare(b);
}).map((tz: string) => {
  const timezone = MomentTimezone.tz(tz).utcOffset() ? MomentTimezone.tz(tz).format('Z') : '+00:00';
  return {
    id: `${tz}`,
    label: `${tz} (GMT${timezone})`,
    value: `${tz} (GMT${timezone})`,
    offset: timezone
  };
});

export function getTimezoneAbbreviationOnDate(date: Date, timezone: string): string {
  const nonDeprecatedTimezone = convertDeprecatedTimezone(timezone);
  let timezoneAbbrev = moment.tz.zone(nonDeprecatedTimezone.split(' ')[0])?.abbr(Number(date)) || '';

  if (timezoneAbbrev.startsWith('+') || timezoneAbbrev.startsWith('-')) {
    timezoneAbbrev = `GMT${timezoneAbbrev}`;
  }

  timezoneAbbrev = getCleanTimezoneAbbrev(timezoneAbbrev, timezone);

  return timezoneAbbrev;
}

export function getTimezoneOffsetInMinutes(date: Date, timezone: string): number {
  const timezoneName = String(timezone.split(' ')[0]);
  const momentZone: moment.MomentZone | null = moment.tz.zone(timezoneName);
  const timestamp = Number(date);
  return momentZone ? momentZone.parse(timestamp) : 0;
}

const getTwoDigitNumber = (string: string = ''): string => {
  return string.length < 2 ? `0${string}` : string;
};

export const getTimezoneOffsetOnGivenDateTime = (dateTime: string | Date, timezone: string): string => {
  const timezoneOffset: number = getTimezoneOffsetInMinutes(
    dateTime instanceof Date ? dateTime : new Date(dateTime),
    timezone
  );
  const symbol = timezoneOffset > 0 ? '-' : '+';
  const timezoneOffsetHours = getTwoDigitNumber(String(Math.abs(parseInt(String(timezoneOffset / 60)))));
  const timezoneOffsetMinutes = getTwoDigitNumber(String(Math.abs(parseInt(String(timezoneOffset % 60)))));

  return `${symbol}${timezoneOffsetHours}:${timezoneOffsetMinutes}`;
};

/**
 * Applies timezone offset to a date object
 * @param date Date
 * @param timezoneGmtSuffix example: +05:30 | -05:30 | +00:00 | -00:00 | +05:00 | -05:00
 */
export function applyGmtSuffixToDate(date: Date, timezoneGmtSuffix: string): Date {
  const regex = /^([+-])(\d{2}):(\d{2})$/;

  if (!regex.test(timezoneGmtSuffix)) {
    throw new Error('Invalid timezone suffix');
  }

  const sign = timezoneGmtSuffix[0];
  const hours = parseInt(timezoneGmtSuffix.slice(1, 3), 10);
  const minutes = parseInt(timezoneGmtSuffix.slice(4, 6), 10);

  date.setMinutes(date.getMinutes() + date.getTimezoneOffset()); // Convert to UTC
  date.setHours(date.getHours() + (sign === '+' ? hours : -hours)); // Add timezone offset
  date.setMinutes(date.getMinutes() + (sign === '+' ? minutes : -minutes)); // Add timezone offset

  return date;
}

export function getNowBasedOnTimezone(timezone: string) {
  if (!timezone) {
    return new Date();
  }

  const timezoneOffset = getTimezoneOffsetOnGivenDateTime(new Date(), timezone);

  if (!timezoneOffset) {
    return new Date();
  }

  return applyGmtSuffixToDate(new Date(), timezoneOffset);
}

export function getCleanTimezoneAbbrev(timezoneAbbrev: string, timezone: string): string {
  let cleanAbbrev = timezoneAbbrev;

  // If timezoneAbbrev is empty or starts with +/- (GMT offset format),
  // try to use the abbreviation part from the timezone string
  if (
    cleanAbbrev === '' ||
    /^[+-]\d{1,2}(:\d{2}|\d{2})?$/.test(cleanAbbrev) ||
    cleanAbbrev.startsWith('GMT') ||
    cleanAbbrev.includes('GMT')
  ) {
    const timezoneParts = timezone?.split(' ');

    if (timezoneParts && timezoneParts.length > 1) {
      cleanAbbrev = timezoneParts[1];
    }
  }

  // Clean up GMT format like (GMT+07:00) to just +07:00
  if (cleanAbbrev.includes('GMT')) {
    cleanAbbrev = cleanAbbrev.replace(/^\(GMT([+-]\d{2}:\d{2})\)$/, '$1');
    // Also handle GMT format without parentheses
    cleanAbbrev = cleanAbbrev.replace(/^GMT([+-]\d{2}:\d{2})$/, '$1');
  }

  return cleanAbbrev;
}
